import {
  LOADING_AUTHENTICATION,
  STORE_USER,
} from '../types';

const initialState = {
  user: null,
  isAuthorizedUser: false,
  isLoadingAuthentication: true,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
  case STORE_USER:
    return {
      ...state,
      user: action.user,
      isAuthorizedUser: action.isAuthorizedUser,
      isLoadingAuthentication: false,
    };
  case LOADING_AUTHENTICATION:
    return {
      ...state,
      isLoadingAuthentication: true,
    };
  default:
    return state;
  }
};

export default authReducer;
